export default "__VITE_ASSET__69753fdc__"